module.exports = __webpack_public_path__ + "img/event-active.69fa58db.png";